import React from 'react';
import styles from '../css/components/field.module.css';

export default function Field({ label, labelRight = null, children, className = '', error = '' }) {
  const hasError = Boolean(error);
  return (
    <div className={`${styles.field} ${className}`.trim()} aria-invalid={hasError || undefined}>
      {(label || labelRight) && (
        <div className={styles.labelRow}>
          {label && <label className={styles.label}>{label}</label>}
          {labelRight && <div className={styles.labelRight}>{labelRight}</div>}
        </div>
      )}
      <div className={styles.control}>{children}</div>
      {hasError && (
        <div style={{ color: '#dc2626', fontSize: 12, marginTop: 4 }} role="alert">{error}</div>
      )}
    </div>
  );
}
